import React from 'react';
import type { PapiDeviation } from '@wix/da-papi-types';
import ThumbOverlayDefault from '@wix/da-ds/pkg/thumbs/ThumbOverlayDefault';

interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  isFaved?: boolean;
  hasCommentedOn?: boolean;
  className?: string;
}

const DeviationThumbOverlayTier: React.FC<React.PropsWithChildren<Props>> = ({
  width,
  height,
  children,
  className,
}) => {
  return (
    <ThumbOverlayDefault
      width={width}
      height={height}
      isFaved={false}
      isCommented={false}
      statusIndicators={undefined}
      isMultiImage={false}
      mediaIndicator={undefined}
      className={className}
    >
      {children}
    </ThumbOverlayDefault>
  );
};
DeviationThumbOverlayTier.displayName = 'DeviationThumbOverlayTier';

export default DeviationThumbOverlayTier;
